module.exports = __webpack_public_path__ + "img/award-simple.689c47ca.svg";